import { Fragment, useEffect } from 'react';

import {
  VENUES_TAXONOMY_KEY,
  PHOTOGRAPHERS_TAXONOMY_KEY,
  VIDEOGRAPHERS_TAXONOMY_KEY,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';

import type { FormApi } from 'final-form';

import {
  AccountWeddingPreferencesView,
  AccountVendorPreferencesView,
  OptionFacetView,
} from '~/types/responseTypes';

interface QuestionBlockType {
  form: unknown;
  weddingPreferences: AccountWeddingPreferencesView;
  vendorPreference: AccountVendorPreferencesView;
  activeVendorType: string;
  children: React.ReactNode;
}

export const QuestionBlock = ({
  form,
  weddingPreferences,
  vendorPreference,
  activeVendorType,
  children,
}: QuestionBlockType): JSX.Element => {
  const {
    mutators: { setField },
  } = form as FormApi;

  useEffect(() => {
    const setCommonFields = (vendorPref: AccountVendorPreferencesView) => {
      setField('serviceEndPriceCents', vendorPref.serviceEndPriceCents / 100);
      setField('flexibleOnPrice', vendorPref.flexibleOnPrice);
      setField(
        'optionFacetKeys',
        vendorPref.facetsView?.map((facet: OptionFacetView) => facet.key)
      );
    };
    if (weddingPreferences) {
      if (vendorPreference) {
        setCommonFields(vendorPreference);
      }
      switch (activeVendorType) {
        case VENUES_TAXONOMY_KEY: {
          setField('guestCount', weddingPreferences.guestCount);
          setField('flexibleOnGuestCount', weddingPreferences.flexibleOnGuestCount);
          break;
        }
        case PHOTOGRAPHERS_TAXONOMY_KEY: {
          if (vendorPreference) {
            setField(
              'photographyStyle',
              (
                vendorPreference.facetsView.find((facet: OptionFacetView) =>
                  facet.key.startsWith('photography-style')
                ) || {}
              ).key
            );
          }
          break;
        }
        case VIDEOGRAPHERS_TAXONOMY_KEY: {
          if (vendorPreference) {
            setField(
              'videographyStyle',
              (
                vendorPreference.facetsView.find((facet: OptionFacetView) =>
                  facet.key.startsWith('photography-style')
                ) || {}
              ).key
            );
          }
          break;
        }
        default: {
          break;
        }
      }
    }
  }, [weddingPreferences, vendorPreference, setField, activeVendorType]);

  return <Fragment>{children}</Fragment>;
};
